import React from 'react'

const Testimonial = ({ 
  name, 
  company, 
  position, 
  avatar, 
  testimonial,
  linkedinUrl,
  className = "" 
}) => {
  return (
    <div className={`bg-white rounded-2xl p-6 border border-neutral-200 shadow-sm flex flex-col h-full ${className}`}>
      {/* Testimonial Content */}
      <div className="flex-1 mb-6">
        <p className="text-neutral-600 leading-relaxed text-sm">
          "{testimonial}"
        </p>
      </div>
      
      {/* Client Info */}
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-neutral-100 flex items-center justify-center flex-shrink-0">
          {avatar ? (
            <img 
              src={avatar} 
              alt={name}
              className="w-full h-full rounded-full object-cover"
            />
          ) : (
            <span className="text-neutral-500 text-sm font-medium">
              {name.split(' ').map(n => n[0]).join('')}
            </span>
          )}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <h4 className="text-sm font-semibold text-neutral-900 truncate">
              {name}
            </h4>
            {linkedinUrl && (
              <a 
                href={linkedinUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium text-white"
                style={{ backgroundColor: 'rgb(0, 119, 181)' }}
              >
                <svg 
                  className="w-3 h-3" 
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037c-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85c3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.06 2.06 0 0 1-2.063-2.065a2.064 2.064 0 1 1 2.063 2.065m1.782 13.019H3.555V9h3.564zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0z"/>
                </svg>
                Verified
              </a>
            )}
          </div>
          <p className="text-xs text-neutral-500 truncate">
            {position} at {company}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Testimonial
